import { ServiceAgreementBody, ServiceAgreementStatusEnum } from '../../../api/generated/pm';

export type ServiceAgreementStatus = ServiceAgreementStatusEnum | ServiceAgreementExpiredEnum;

export interface ServiceAgreement extends ServiceAgreementBody {
  readonly requestExpiresIn?: number;
  readonly computedServiceAgreementStatus: ServiceAgreementStatus;
}

export enum ServiceAgreementExpiredEnum {
  Expired = 'expired',
}

export const SA_STATUS_PRIORITY = new Map<ServiceAgreementStatus, number>([
  [ServiceAgreementStatusEnum.INVITED, 0],
  [ServiceAgreementStatusEnum.PENDING, 1],
  [ServiceAgreementStatusEnum.DECLINED, 2],
  [ServiceAgreementExpiredEnum.Expired, 3],
  [ServiceAgreementStatusEnum.ACTIVE, 4],
]);

export type ListPage = string;
export type ListLimit = string;

export interface BaseListFilters {
  page: ListPage;
  limit: ListLimit;
  name?: string;
}

export interface SAListFilters extends BaseListFilters {
  statuses?: ServiceAgreementStatus[];
}

export type RevokeAgreementType = 'cancel' | 'delete';
